<template>
    <v-form @submit.prevent="form.get(route('help-articles.index'))">
        <v-text-field
            autofocus
            rounded
            solo
            height="64"
            style="border-radius: 36px !important"
            label="What do you need help with?"
            placeholder="What do you need help with?"
            name="s"
            append-icon="search"
            hide-details
            v-model="form.s"
        />
    </v-form>
</template>

<script>
export default {
    props: {
        searchTerm: {
            type: String,
            default: function () {
                return "";
            },
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                s: this.searchTerm,
            }),
        };
    },
};
</script>
